var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","pt-5":"","mt-4":""}},[(_vm.isUserLoggedIn)?_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":"","pa-1":""}},[_c('users-search-panel')],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":"","pa-1":""}},[_c('users-panel')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ee29b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UsersIndex.vue
// module id = null
// module chunks = 